import React from 'react';
import { Breadcrumbs, Link, Grid, Card, CardActionArea, CardActions, CardContent, CardMedia, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { withTranslation } from 'react-i18next';
import { push as Push } from 'redux-first-history';

import { ApplicationState as State } from '@api/store';
import { LegalProps } from './LegalInterface';

const elements = [
    {
        title: 'Data Processing Addendum',
        caption:
            'By reading this information and using Elastic Email, please know that you are agreeing to the following terms and policies.',
        url: '/my-account/legal/dpa',
    },
    {
        title: 'Terms Of Use',
        caption: 'Please read these Terms of Use (the “Terms”) carefully.',
        url: '/my-account/legal/termsofuse',
    },
    {
        title: 'Privacy Policy',
        caption: 'This Privacy Policy (the “Policy”) describes the personal data that Elastic Email Inc',
        url: '/my-account/legal/privacypolicy',
    },
    {
        title: 'Acceptable Use Policy',
        caption: 'This Acceptable Use Policy (the “Policy”) sets out the rules applicable to your use of the Elastic Email Inc. ',
        url: '/my-account/legal/acceptableusepolicy',
    },
    {
        title: 'Anti-Spam Policy',
        caption: 'This Anti-Spam Policy (the “Policy”) sets out the rules applicable to your use of the Elastic Email Inc. ',
        url: '/my-account/legal/antispampolicy',
    },
    {
        title: 'Security',
        caption:
            'At Elastic Email, we take the security of your privacy and data extremely seriously and we want to be as transparent as possible with how we conduct business around security measures. ',
        url: '/my-account/legal/security',
    },
    {
        title: 'Cookies',
        caption:
            'Elastic Email uses Website Navigational Information to collect information about how our visitors and users navigate our websites',
        url: '/my-account/legal/cookies',
    },
];

const useStyles = makeStyles({
    card: {
        maxWidth: 345,
    },
    media: {
        height: 140,
    },
});

const MapState = (state: State, ownProps: LegalProps): any => {
    return {
        ...ownProps,
        browser: state.browser,
    };
};

type DispatchActions = {
    Push(url: string): void;
};

type Props = LegalProps & DispatchActions;

const dispatchActions = { Push };

const Legal: React.FC<Props> = (props: Props): JSX.Element => {
    const classes = useStyles({});

    return (
        <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center">
            <Typography variant="h1" align="left">
                {props.t('legal')}
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
                <Link onClick={(): void => props.Push('/my-account')}>My account</Link>
                <Link>Legal</Link>
            </Breadcrumbs>

            <Grid container spacing={0} direction="row" alignItems="flex-start" justifyContent="flex-start">
                {elements.map((elem, index) => {
                    return (
                        <Card className={classes.card} key={index}>
                            <CardActionArea>
                                <CardMedia
                                    className={classes.media}
                                    image="/static/images/cards/contemplative-reptile.jpg"
                                    title="Contemplative Reptile"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="h2">
                                        {elem.title}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {elem.caption}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary">
                                    Learn More
                                </Button>
                            </CardActions>
                        </Card>
                    );
                })}
            </Grid>
        </Grid>
    );
};

export default compose(connect<LegalProps, DispatchActions>(MapState, dispatchActions), withTranslation())(Legal);
